    <form [formGroup]="formulario.formGroup">
        <fieldset>
        
        <div class="row">
            <div class="form-group col-2">
                <label class="control-label small" for="codigoAcesso">Código de Acesso:</label>
            </div>
            <div class="form-group col-sm-6">
                <input [formControlName]="formulario.campos.codigoAcesso?.name"   maxlength="6" size="6">
            </div>
        </div>

        <div class="row">
                <div class="form-group col-2">
                    <label class="control-label small" for="login">Login:</label>
                </div>
                <div class="form-group col-sm-6">
                    <input [formControlName]="formulario.campos.login?.name"   maxlength="8">
                </div>
        </div>

        <div class="row">
                <div class="form-group col-2">
                    <label class="control-label small" for="senha">Senha:</label>
                </div>
                <div class="form-group col-sm-6">
                    <input [formControlName]="formulario.campos.senha?.name"   type="password" maxlength="20">
                </div>
        </div>
        
        </fieldset>
        
        <button class="btn btn-success" (click)="realizarAcessoExterno()">Acessar</button> 

    </form> 




